import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import vueHljs from "vue-hljs";
//if you want to use default color, import this css file
import "vue-hljs/dist/vue-hljs.min.css";

import BeeGridTable from "beegridtable";
import BeeLocale from "beegridtable/src/locale"; //default English

import 'beegridtable/dist/styles/beegridtable.css';

Vue.use(BeeGridTable, {
  locale:BeeLocale,
  capture: true,
});

Vue.use(vueHljs)

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
